import type { PopulatedItem } from '@game/game-data';

export function getItemSalePrice(item: PopulatedItem, quality: number, quantity: number): number {
  return item.worthMultiplier * quantity * (quality + 1);
}
